'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { IPaginatedData } from '../../../models/ICommon';
import { apiService } from '../../../services/ApiService';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Loader from '../../components/svg/Loader';
import LoadMoreButton from '../../components/LoadMoreButton';
import { setQueryParam } from '../../../utils/querystring';
import { IPollsCollection } from '../../../models/IPoll';
import Image from 'next/image';
import FallBackImage from '../../components/FallBackImage';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import Participants from '../../components/svg/Participants';
import PollIcon from '../../components/svg/PollIcon';
import SectionTitle from '../../components/SectionTitle';
import { IPoll } from '../../../models/IPoll';
import Poll from '../../components/Poll';


interface Props {
  data: IPollsCollection;
  collectionSlug: string;
}

export default function PollsWrapper({data, collectionSlug}:Props) {

  return (
    <div className='flex flex-col gap-[24px] mx-auto max-w-[860px] w-full'>
      <div className='w-full flex flex-col gap-[24px]'>

      <div className='flex items-center gap-[24px] flex-wrap w-fit'>
      <SectionTitle title={data.titleAr}/>
      <span className='h5'>(إجمالي الاستطلاعات {data.polls.length})</span>
      </div>
      
      {data.descriptionAr ? <span className='sm desktop:md dark:text-white'>{data.descriptionAr}</span> : null}
      </div>
      <div className='flex flex-col gap-[24px]'>
      {data.polls.map((p,i) => <Poll collectionSlug={collectionSlug} showCreatedOn data={{poll: p, pollUniqueCode: p.uniqueCode}}/>)}
</div>


    </div>
  )
}